import React from 'react';
import { Button, Flex, Heading } from "@magnetic/core";
import { Notification } from "@magnetic/notification";
import OrganizationSelector from "../../consent/OrganizationSelector";
import { Organization } from "../../../helpers/pre-authorization-transformer";

type OrganizationListProps = {
  organizations: Organization[];
  selectedOrganization: Organization;
  authorizeError: string,
  setSelectedOrganization: (organization: Organization) => void;
  handleOrganizationCancel: () => void;
  authorizeOrganization: () => void;
}

const OrganizationList = ({ organizations, selectedOrganization, authorizeError, setSelectedOrganization, handleOrganizationCancel, authorizeOrganization }: OrganizationListProps) => {

  return (
      <Flex direction="vertical" gap="xs" className="device-auth-flex">
        <Flex direction="vertical">
          <Heading>Select which organization you would like to view</Heading>
        </Flex>
        <Flex direction="vertical" gap={8}>
          <OrganizationSelector
            organizations={organizations}
            selectedOrganization={selectedOrganization}
            fullWidthSelector={true}
            onChange={async (orgName) => {
              const organization = organizations.find(
                (organization) => organization.name === orgName
              );
              setSelectedOrganization(organization);
            }}
          />
          {authorizeError && (
            <Notification status="negative">{authorizeError}</Notification>
          )}
        </Flex>
        <Flex justify="flex-end" style={{ marginTop: "30px" }}>
          <Button.Group>
            <Button kind="tertiary" onClick={handleOrganizationCancel}>
              Cancel
            </Button>
            <Button
              kind="primary"
              onClick={authorizeOrganization}
              disabled={!selectedOrganization}
            >
              Connect
            </Button>
          </Button.Group>
        </Flex>
      </Flex>
  );
};

export default OrganizationList;